import { ReactElement } from 'react';

import { MENU_CLASS } from '../../utils/constants';
import { menuConsts } from './Menu.consts';
import * as Styled from './Menu.styles';
import { IMenuProps } from './Menu.types';

const Menu = ({
  className = '',
  mode = 'inline',
  size = 'medium',
  alignment = 'start',
  emphasis = false,
  indicatorPosition = 'right',
  ...rest
}: IMenuProps): ReactElement => (
  <Styled.Menu
    prefixCls={MENU_CLASS}
    id={MENU_CLASS}
    className={className}
    size={size}
    mode={mode}
    alignment={alignment}
    inlineIndent={alignment === 'center' ? 0 : menuConsts[size].padding}
    expandIcon={null}
    getPopupContainer={(element) => element}
    $leftIndicator={indicatorPosition === 'left'}
    $emphasis={emphasis}
    {...rest}
  />
);

export default Menu;
